export default __webpack_public_path__ + "static/media/apad.6223501e.png";